<template>
  <main class="main page-inside products-page product-list-page">
    <div class="main-wrapper">
      <div class="section page-top-section">
        <div class="wrapper">
          <div class="title title-96">SHOP</div>
          <img src="./../images/crew.webp" class="img" />
        </div>
      </div>
      <div class="section page-body-section">
        <div class="circle"></div>
        <img src="./../images/squares.webp" class="squares" />
        <div class="title title-64">{{ $t(activeCategory.title) }}</div>

        <div class="wrapper">
          <router-link to="/shop" class="back"></router-link>
          <div class="flex">
            <div class="filters-block filters-price">
              <div class="val-container">
                <div class="val min">
                  <div class="desc small">
                    <b>From</b>
                  </div>
                  <input type="text" v-model="barMinValue" />
                  <img src="./../images/coin.svg" class="img" />
                </div>
                <div class="val max">
                  <div class="desc small">
                    <b>To</b>
                  </div>
                  <input type="text" v-model="barMaxValue" />
                  <img src="./../images/coin.svg" class="img" />
                </div>
              </div>
            </div>
            <div class="search-container">
              <input type="text" v-model="search" placeholder="Search" />
              <img src="./../images/glass.svg" class="img" />
            </div>
            <div class="sort-container">
              <div
                class="select-container"
                v-if="sortOptions && sortOptions.length"
              >
                <Select2
                  class="select2 single"
                  v-model="sort"
                  @select="selectSort($event)"
                  :options="sortOptions"
                  placeholder="Highest price first"
                />
              </div>
            </div>
          </div>
          <transition name="fade">
            <div class="list products" v-if="products">
              <div class="item" v-for="(item, i) in products" :key="i">
                <ProductCard
                  :item="item"
                  :addToCartChosenItem="addToCartChosenItem"
                  @goToProduct="goToProduct"
                  :currency="currency"
                  @addToCart="addToCart"
                />
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import ProductCard from "../components/ProductCard.vue";
import Select2 from "vue3-select2-component";
export default {
  name: "Products",
  props: ["addToCartChosenItem", "currency", "activeCategory"],
  components: {
    ProductCard,
    Select2,
  },
  data: function () {
    return {
      products: [],
      category: "",
      sortOptions: [],
      sort: "desc",
      barMinValue: 0,
      barMaxValue: 200000,
      search: "",
    };
  },

  watch: {
    currency: function () {
      if (this.currency) {
        this.getProducts();
      }
    },
    activeCategory: function () {
      this.getProducts();
    },
    sort() {
      this.getProducts();
    },

    barMinValue: function () {
      this.getProducts();
    },
    barMaxValue: function () {
      this.getProducts();
    },
    search() {
      this.activePage = 1;
      this.getProducts();
    },
  },
  mounted() {
    this.getProducts();
    this.sortOptions = [
      {
        id: "desc",
        text: "Highest price first",
      },
      {
        id: "asc",
        text: "Lowest price first",
      },
    ];
  },
  methods: {
    selectSort(event) {
      this.sort = event.id;
    },
    getProducts() {
      let addSort = "&sort=" + this.sort;
      let addPrice =
        "&price_from=" + this.barMinValue + "&price_till=" + this.barMaxValue;

      let addSearch = "&search=" + this.search;

      if (this.activeCategory && this.currency && this.currency.length > 1) {
        this.$http
          .get(
            process.env.VUE_APP_API +
              "products?currency=" +
              this.currency +
              addSort +
              addPrice +
              addSearch +
              (this.activeCategory.id
                ? "&category_id=" + this.activeCategory.id
                : "")
          )
          .then((res) => {
            this.products = res.data.payload;
          });
      }
    },
    goToProduct(item) {
      this.$emit("goToProduct", item);
    },
    addToCart(item, id) {
      this.$emit("addToCart", item, id);
    },
  },
};
</script>
